import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '爱情岛路线导航',
  url: 'https://aiqingdao-line.com',
  description: '整理最新可用免费路线入口、访问方法及使用技巧，帮助用户快速稳定访问爱情岛一论坛。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://aiqingdao-line.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '爱情岛路线导航',
  url: 'https://aiqingdao-line.com',
  description: '致力于为用户提供爱情岛一论坛最新免费路线入口和访问教程。',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '爱情岛一论坛免费路线是否安全可靠？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '本站整理的所有路线均经过严格验证，确保来源安全可靠。建议通过本站提供的官方推荐路线进行访问。',
      },
    },
    {
      '@type': 'Question',
      name: '如何选择最适合自己的访问路线？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '建议根据网络环境和地理位置选择路线。优先使用主路线，如果不可用可尝试备用路线或镜像站点。',
      },
    },
    {
      '@type': 'Question',
      name: '访问路线多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '每日检查路线可用状态，一旦发现路线不可用会第一时间更新。常规情况下每周发布路线状态报告。',
      },
    },
    {
      '@type': 'Question',
      name: '路线突然无法访问怎么办？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '首先尝试刷新页面或清除浏览器缓存。如果问题依旧，切换至备用路线。如仍无法解决，查看常见问题页面或联系我们。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="爱情岛一论坛免费路线 - 最新访问指南"
        description="想找爱情岛一论坛免费路线？本页整理最新可用免费路线入口、访问方法及使用技巧，帮助用户快速稳定访问爱情岛一论坛，无需付费，操作简单，持续更新最新线路，收藏备用不迷路。"
        keywords="爱情岛一论坛免费路线,爱情岛论坛免费入口,爱情岛一论坛最新地址,爱情岛免费线路访问,爱情岛论坛路线更新,免费论坛路线导航,爱情岛一论坛访问教程"
        canonicalUrl="https://aiqingdao-line.com"
        ogType="website"
        schemaJson={[orgSchema, homeSchema, faqSchema]}
      />
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <LatestArticles />
          <FAQSection />
          <NewsletterSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}